import * as React from "react";

import { useSidebar } from "@replohq/lattice/components/sidebar/Sidebar";
import { cn } from "@replohq/lattice/utils/cn";

export const SidebarCardCarousel: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const { open } = useSidebar();

  const cards = React.Children.toArray(children);
  const totalCards = cards.length;
  const clampedIndex = Math.min(activeIndex, totalCards - 1);

  if (totalCards === 0) {
    return null;
  }

  if (totalCards === 1) {
    return <>{cards[0]}</>;
  }

  if (!open) {
    return (
      <div className="flex flex-col gap-2 items-center">
        {cards.map((card, index) => (
          <div key={index}>{card}</div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="relative overflow-hidden">
        {cards.map((card, index) => (
          <div
            key={index}
            className={cn(
              "transition-opacity duration-300",
              index === clampedIndex
                ? "opacity-100"
                : "opacity-0 absolute inset-0 pointer-events-none",
            )}
          >
            {card}
          </div>
        ))}
      </div>

      {/* Dot indicators */}
      <div className="flex items-center justify-center gap-1.5">
        {cards.map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setActiveIndex(index)}
            aria-label={`Go to card ${index + 1}`}
            className={cn(
              "w-1.5 h-1.5 rounded-full transition-colors duration-200",
              index === clampedIndex ? "bg-black" : "bg-black/20",
            )}
          />
        ))}
      </div>
    </div>
  );
};
